import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/layout/DashboardLayout";

import Landing from "./pages/Landing";
import Careers from "./pages/Careers";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";

import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import EmployeeProfile from "./pages/EmployeeProfile";
import Attendance from "./pages/Attendance";
import Leaves from "./pages/Leaves";
import Recruitment from "./pages/Recruitment";
import Documents from "./pages/Documents";
import Meetings from "./pages/Meetings";
import Notifications from "./pages/Notifications";
import Settings from "./pages/Settings";
import SelfService from "./pages/SelfService";
import ExitManagement from "./pages/ExitManagement";
import Projects from "./pages/Projects";
import Tasks from "./pages/Tasks";
import Payroll from "./pages/Payroll";
import Billing from "./pages/Billing";
import Forms from "./pages/Forms";
import TeamDirectory from "./pages/TeamDirectory";
import Profile from "./pages/Profile";
import Tracking from "./pages/Tracking";
import Alumni from "./pages/Alumni";
import Chat from "./pages/Chat";
import AdminStudio from "./pages/AdminStudio";

import Interns from "./pages/documents/Interns";
import Certificates from "./pages/documents/Certificates";
import ExperienceLetters from "./pages/documents/ExperienceLetters";
import RecommendationLetters from "./pages/documents/RecommendationLetters";
import OfferLetters from "./pages/documents/OfferLetters";
import NdaDocuments from "./pages/documents/NdaDocuments";
import VerificationLogs from "./pages/documents/VerificationLogs";
import Templates from "./pages/documents/Templates";
import DocSettings from "./pages/documents/DocSettings";
import VerifySearch from "./pages/documents/VerifySearch";
import VerifyResult from "./pages/documents/VerifyResult";

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/verify" element={<VerifySearch />} />
                        <Route path="/verify/:certificateId" element={<VerifyResult />} />

                        <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/employees" element={<ProtectedRoute roles={["super_admin", "hr", "manager"]}><Employees /></ProtectedRoute>} />
                            <Route path="/employees/:id" element={<EmployeeProfile />} />
                            <Route path="/attendance" element={<Attendance />} />
                            <Route path="/leaves" element={<Leaves />} />
                            <Route path="/recruitment" element={<ProtectedRoute roles={["super_admin", "hr", "manager"]}><Recruitment /></ProtectedRoute>} />
                            <Route path="/documents" element={<Documents />} />
                            <Route path="/meetings" element={<Meetings />} />
                            <Route path="/notifications" element={<Notifications />} />
                            <Route path="/self-service" element={<SelfService />} />
                            <Route path="/exit" element={<ExitManagement />} />
                            <Route path="/settings" element={<ProtectedRoute roles={["super_admin", "hr"]}><Settings /></ProtectedRoute>} />
                            <Route path="/projects" element={<Projects />} />
                            <Route path="/tasks" element={<Tasks />} />
                            <Route path="/payroll" element={<Payroll />} />
                            <Route path="/billing" element={<ProtectedRoute roles={["super_admin", "hr"]}><Billing /></ProtectedRoute>} />
                            <Route path="/forms" element={<Forms />} />
                            <Route path="/tracking" element={<ProtectedRoute roles={["super_admin"]}><Tracking /></ProtectedRoute>} />
                            <Route path="/admin-studio" element={<ProtectedRoute roles={["super_admin"]}><AdminStudio /></ProtectedRoute>} />
                            <Route path="/alumni" element={<ProtectedRoute roles={["super_admin", "hr", "manager", "lead"]}><Alumni /></ProtectedRoute>} />
                            <Route path="/team" element={<TeamDirectory />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/chat" element={<Chat />} />
                            
                            {/* HR Documents Admin Routes */}
                            <Route path="/interns" element={<ProtectedRoute roles={["super_admin", "hr"]}><Interns /></ProtectedRoute>} />
                            <Route path="/documents/certificates" element={<ProtectedRoute roles={["super_admin", "hr"]}><Certificates /></ProtectedRoute>} />
                            <Route path="/documents/experience" element={<ProtectedRoute roles={["super_admin", "hr"]}><ExperienceLetters /></ProtectedRoute>} />
                            <Route path="/documents/recommendation" element={<ProtectedRoute roles={["super_admin", "hr"]}><RecommendationLetters /></ProtectedRoute>} />
                            <Route path="/documents/offers" element={<ProtectedRoute roles={["super_admin", "hr"]}><OfferLetters /></ProtectedRoute>} />
                            <Route path="/documents/ndas" element={<ProtectedRoute roles={["super_admin", "hr"]}><NdaDocuments /></ProtectedRoute>} />
                            <Route path="/documents/logs" element={<ProtectedRoute roles={["super_admin", "hr"]}><VerificationLogs /></ProtectedRoute>} />
                            <Route path="/documents/templates" element={<ProtectedRoute roles={["super_admin", "hr"]}><Templates /></ProtectedRoute>} />
                            <Route path="/documents/settings" element={<ProtectedRoute roles={["super_admin", "hr"]}><DocSettings /></ProtectedRoute>} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                    <Toaster richColors position="top-right" />
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
